import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { Word } from '../../../containers';
import { WID } from '../../../constants/Language';
import { Card, CardActions, CardHeader, CardContent, Fade, FormGroup, FormControlLabel, Switch, InputAdornment, Input } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { makePath } from '../../../lib'
import { useEffect } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { SettingsContext } from '../../Settings';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../actions';

const mode = process.env.NODE_ENV !== 'production' || window.location.port === '3000' ? "sandbox" : "live"

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit * 2,
  },
  typeButtons: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    marginBottom: theme.spacing.unit * 2,
  },
  typeButton: {
    margin: theme.spacing.unit,
  },
  amountButtons: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    marginBottom: theme.spacing.unit * 2,
  },
  customAmount: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    marginBottom: theme.spacing.unit * 2,
  },
  amountButton: {
    margin: theme.spacing.unit,
    height: theme.spacing.unit * 4,
  },
  paypalButton: {
    margin: theme.spacing.unit * 2,
  },
  formControl: {
    width: 80,
  },
  inputAmount: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: 'auto',
    width: 80,
  },
  inputAdornment: {
    marginRight: theme.spacing.unit,
  },
  cardActions: {
    justifyContent: 'center',
  },
  description: {
    marginBottom: theme.spacing.unit * 4,
  },
  sentence: {
    lineHeight: 1.75,
    marginBottom: theme.spacing.unit * 1,
  },
  cardActionsForLogin: {
    marginBottom: theme.spacing.unit * 3,
  },
  appreciation: {
    lineHeight: 2,
  }
})

const PAYMENT_TYPE = {
  GIVE_MONTHLY: "GIVE_MONTHLY",
  JUST_ONCE: "JUST_ONCE",
}

const paymentPropsList = [
  { paymentType: PAYMENT_TYPE.GIVE_MONTHLY, label: <Word wid={WID.PAYPAL_CARD.GIVE_MONTHLY}/> },
  { paymentType: PAYMENT_TYPE.JUST_ONCE, label: <Word wid={WID.PAYPAL_CARD.JUST_ONCE}/> },
]

const PLAN_ID = mode === "live" ? {
  DONATION_GIVE_MONTHLY_500:   'P-8MT11832KH857293BLZU25YY',
  DONATION_GIVE_MONTHLY_1000:  'P-9J246666G4365313JLZU26AI',
  DONATION_GIVE_MONTHLY_1500:  'P-6P915212PW9268603LZU26HI',
  DONATION_JUST_ONCE_500:      'DONATION_JUST_ONCE_500',
  DONATION_JUST_ONCE_1000:     'DONATION_JUST_ONCE_1000',
  DONATION_JUST_ONCE_3000:     'DONATION_JUST_ONCE_3000',
  DONATION_JUST_ONCE_5000:     'DONATION_JUST_ONCE_5000',
  DONATION_JUST_ONCE_10000:    'DONATION_JUST_ONCE_10000',
  DONATION_JUST_ONCE_CUSTOM:   'DONATION_JUST_ONCE_CUSTOM',
} : {
  DONATION_GIVE_MONTHLY_500:   'P-115964278V3130416LYXNC7Q',
  DONATION_GIVE_MONTHLY_1000:  'P-2NJ681683W242832ELY5ZTZI',
  DONATION_GIVE_MONTHLY_1500:  'P-3LM50871M0992702JLY5Z7UY',
  DONATION_JUST_ONCE_500:      'DONATION_JUST_ONCE_500',
  DONATION_JUST_ONCE_1000:     'DONATION_JUST_ONCE_1000',
  DONATION_JUST_ONCE_3000:     'DONATION_JUST_ONCE_3000',
  DONATION_JUST_ONCE_5000:     'DONATION_JUST_ONCE_5000',
  DONATION_JUST_ONCE_10000:    'DONATION_JUST_ONCE_10000',
  DONATION_JUST_ONCE_CUSTOM:   'DONATION_JUST_ONCE_CUSTOM',
}

const planPropsList = [
  { paymentType: PAYMENT_TYPE.GIVE_MONTHLY, amount: 500,   currency: 'JPY', planID: PLAN_ID.DONATION_GIVE_MONTHLY_500 },
  { paymentType: PAYMENT_TYPE.GIVE_MONTHLY, amount: 1000,  currency: 'JPY', planID: PLAN_ID.DONATION_GIVE_MONTHLY_1000 },
  { paymentType: PAYMENT_TYPE.GIVE_MONTHLY, amount: 1500,  currency: 'JPY', planID: PLAN_ID.DONATION_GIVE_MONTHLY_1500 },
  { paymentType: PAYMENT_TYPE.JUST_ONCE,    amount: 500,   currency: 'JPY', planID: PLAN_ID.DONATION_JUST_ONCE_500 },
  { paymentType: PAYMENT_TYPE.JUST_ONCE,    amount: 1000,  currency: 'JPY', planID: PLAN_ID.DONATION_JUST_ONCE_1000 },
  { paymentType: PAYMENT_TYPE.JUST_ONCE,    amount: 3000,  currency: 'JPY', planID: PLAN_ID.DONATION_JUST_ONCE_3000 },
  { paymentType: PAYMENT_TYPE.JUST_ONCE,    amount: 5000,  currency: 'JPY', planID: PLAN_ID.DONATION_JUST_ONCE_5000 },
  { paymentType: PAYMENT_TYPE.JUST_ONCE,    amount: 10000, currency: 'JPY', planID: PLAN_ID.DONATION_JUST_ONCE_10000 },
]

const STATUS = {
  INPUT: 'INPUT',
  APPROVED: 'APPROVED'
}

const PayPalCard = withStyles( styles, { withTheme: true } )((props) => {
  const { classes, user, isAuthStateChange, settings } = props

  const [isInitialized, setIsInitialized] = useState(false)
  const [status, setStatus] = useState(STATUS.INPUT)
  const [paymentType, setPaymentType] = useState(PAYMENT_TYPE.GIVE_MONTHLY)
  const [amountError, setAmountError] = useState(false)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const { planID, amount } = useSelector(state => state.paypal)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isInitialized) {
      dispatch(actions.init())
      dispatch(actions.changedPlan(planPropsList[0].planID))

      window.paypal.Buttons({
        createSubscription: (data, acts) => {
          return dispatch(actions.createSubscription(acts))
        },
        onApprove: (data, acts) => {
          dispatch(actions.approveSubscription({
            orderID: data.orderID,
            subscriptionID: data.subscriptionID,
          }))
          setStatus(STATUS.APPROVED)
        }
      }).render('#paypal-give-monthly-button-container');

      window.paypal.Buttons({
        createOrder: (data, acts) => {
          return dispatch(actions.createOrder(planID, amount))
          .then(response => {
            return response.orderID
          })
        },
        onApprove: (data, acts) => {
          dispatch(actions.approveOrder({
            orderID: data.orderID,
            payerID: data.payerID,
          }))
          setStatus(STATUS.APPROVED)
        }
      }).render('#paypal-just-once-button-container');

      setIsInitialized(true)
    }
  }, [isInitialized])

  const handleClickTypeButton = ( targetPaymentType ) => () => {
    var foundProps
    if (targetPaymentType !== paymentType) {
      foundProps = planPropsList.find(planProps => planProps.paymentType === targetPaymentType)
      setPaymentType(targetPaymentType)
      dispatch(actions.changedPlan(foundProps.planID))
    }
  }

  const handleClickAmountButton = ( targetPlanID ) => () => {
    dispatch(actions.changedPlan(targetPlanID))
  }

  const handleChangeAmount = (event) => {
    dispatch(actions.changedAmount(isNaN(event.target.value) ? amount : parseInt(event.target.value, 10)))
    setAmountError(Boolean(isNaN(amount) || 500 > amount || 100000 < amount))
  }

  const handleClickSwitch = (name) => (event) => {
    props.handleClickSwitch({ [name]: event.target.checked })
  }

  var amountPropsList = planPropsList.filter( planProps => planProps.paymentType === paymentType )
  return (
    <React.Fragment>
    <Fade in={Boolean(user) && isAuthStateChange && status === STATUS.INPUT}>
      <Card className={classes.paper} style={{ display: Boolean(user) && status === STATUS.INPUT ? "block" : "none" }}>
        <CardHeader></CardHeader>
        <CardContent>
          <div className={classes.description}>
            <Typography className={classes.sentence}>{`RenjuPortalは連珠の情報の集約、連珠コミュニティの形成、上達のサポートを目的としたサイトを目指しております。`}</Typography>
            <Typography className={classes.sentence}>{`魅力ある有償コンテンツで収益を確保しながら、目的実現にむけて開発を進めていきたく考えておりますが、まだそこまでたどりつけておりません。`}</Typography>
            <Typography className={classes.sentence}>{`開発費や工数がかかるばかりで、開発を進めるのが困難な状況です。`}</Typography>
            <Typography className={classes.sentence}>{`そこで、必要最低限な収益を確保できるまでは皆様の支援をいただきたく、寄付システムを導入しました。一度、RenjuPortalへの寄付を検討いただければ幸いです。`}</Typography>
            <Typography className={classes.sentence}>{`最後に、連珠の世界はまだまだWebサービスが充実しておりません。このRenjuPortalで立派なWebサービスを皆さんと一緒に作り上げていきたく存じます。`}</Typography>
            <Typography className={classes.sentence}>{`宜しくお願い申し上げます。`}</Typography>
            <Typography className={classes.sentence} align={"right"}>{`合同会社ふくふく`}</Typography>
            <Typography className={classes.sentence} align={"right"}>{`代表　福井　暢宏`}</Typography>
          </div>
          <Typography variant={'caption'}><Word wid={WID.PAYPAL_CARD.PAYMENT_TYPE}/></Typography>
          <div className={classes.typeButtons}>
            {paymentPropsList.map( paymentProps => 
              <Button
                variant={paymentProps.paymentType === paymentType ? "contained" : "outlined"}
                color={'primary'}
                className={classes.amountButton}
                key={paymentProps.paymentType}
                onClick={handleClickTypeButton( paymentProps.paymentType )}
              >
                {paymentProps.label}
              </Button>
            )}
          </div>
          <Typography variant={'caption'}><Word wid={WID.PAYPAL_CARD.AMOUNT}/></Typography>
          <div className={classes.amountButtons}>
            {amountPropsList.map( amountProps =>
              <Button
                variant={amountProps.planID === planID ? "contained" : "outlined"}
                color={'primary'}
                className={classes.amountButton}
                key={amountProps.planID}
                onClick={handleClickAmountButton( amountProps.planID )}
              >
                {'\u00A5' + amountProps.amount}
              </Button>
            )}
          </div>
          {paymentType === PAYMENT_TYPE.JUST_ONCE && (
            <div className={classes.customAmount}>
              <Button
                variant={PLAN_ID.DONATION_JUST_ONCE_CUSTOM === planID ? "contained" : "outlined"}
                color={'primary'}
                className={classes.amountButton}
                onClick={handleClickAmountButton(PLAN_ID.DONATION_JUST_ONCE_CUSTOM)}
              >
                {<Word wid={WID.PAYPAL_CARD.OTHER}/>}
              </Button>
              <Input
                disabled={PLAN_ID.DONATION_JUST_ONCE_CUSTOM !== planID}
                className={classes.inputAmount}
                value={amount}
                onChange={handleChangeAmount}
                type='number'
                startAdornment={<InputAdornment position="start">{'\u00A5'}</InputAdornment>}
                error={amountError}
              />
            </div>
          )}
        </CardContent>
        <CardActions className={classes.cardActions}>
          <div
            className={classes.paypalButton + " paypal-button"}
            id="paypal-give-monthly-button-container"
            style={{
              display: paymentType === PAYMENT_TYPE.GIVE_MONTHLY ? "block" : "none"
            }}
          >
          </div>
          <div
            className={classes.paypalButton + " paypal-button"}
            id="paypal-just-once-button-container"
            style={{
              display: paymentType === PAYMENT_TYPE.JUST_ONCE ? "block" : "none"
            }}
          >
          </div>
        </CardActions>
      </Card>
    </Fade>
    <Fade in={Boolean(user) && isAuthStateChange && status === STATUS.APPROVED}>
      <Card className={classes.paper} style={{ display: Boolean(user) && status === STATUS.APPROVED ? "block" : "none" }}>
        <CardHeader></CardHeader>
        <CardContent>
          <Typography align={"center"} variant={"subheading"} className={classes.appreciation}>{'RenjuPortalへ寄付していただき'}</Typography>
          <Typography align={"center"} variant={"subheading"} className={classes.appreciation}>{'ありがとうございます。'}</Typography>
        </CardContent>
        <CardActions>
          {settings && (
            <FormGroup>
              <FormControlLabel
                control={<Switch checked={Boolean(settings.isVisibleDonor)} value={'isVisibleDonor'} color='primary' onChange={handleClickSwitch('isVisibleDonor')}/>}
                label={<Word wid={WID.DONATION_SETTINGS_CARD.VISIBLE_DONOR}/>}
              />
            </FormGroup>
          )}
        </CardActions>
      </Card>
    </Fade>
    <Fade in={Boolean(user) === false && isAuthStateChange}>
      <Card className={classes.paper} style={{ display: !Boolean(user) ? "block" : "none" }}>
        <CardHeader></CardHeader>
        <CardContent>
          <Typography>{'寄付にはユーザーログインが必要です。'}</Typography>
        </CardContent>
        <CardActions className={classes.cardActionsForLogin}>
          <Button variant={"contained"} color={"primary"} fullWidth component={Link} to={makePath('/login', language)}>{'ログイン'}</Button>
        </CardActions>
      </Card>
    </Fade>
    </React.Fragment>
  )
})

export default PayPalCard



// WEBPACK FOOTER //
// ./src/Parts/PayPalCard/components/PayPalCard.js